import React from "react";
import { useLocation } from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Badge, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Race = () => {
  const location = useLocation();
  const race = location?.state?.race;
  const markers = race?.markers ?? [];
  const mapRef = React.useRef(null);
  const theme = useTheme();
  const [markerIndexSelected, setMarkerIndexSelected] = React.useState(0);
  // const [center, setCenter] = React.useState({ lat: 0, lng: 0 });
  console.log(process.env, race);

  const latMax = Math.max(...markers.map((x) => x.coordinate?.lat ?? x.lat));
  const latMin = Math.min(...markers.map((x) => x.coordinate?.lat ?? x.lat));
  const longMax = Math.max(...markers.map((x) => x.coordinate?.lng ?? x.lng));
  const longMin = Math.min(...markers.map((x) => x.coordinate?.lng ?? x.lng));

  const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height / 2),
  });

  // const bounds = {
  //   ne: {
  //     lat: latMax,
  //     lng: longMax,
  //   },
  //   sw: {
  //     lat: latMin,
  //     lng: longMin,
  //   },
  // };

  // console.log(bounds);

  // const size = {
  //   width: 640, // Map width in pixels
  //   height: 800, // Map height in pixels
  // };

  // const { center: centerBound, zoom } = fitBounds(bounds, size);

  const [active, setActive] = React.useState(false);

  React.useEffect(() => {
    // Vérifiez si la carte et les marqueurs sont chargés
    if (mapRef?.current && active) {
      const bounds = new window.google.maps.LatLngBounds();

      // Étendez les limites pour chaque marqueur
      markers.forEach((marker) => {
        bounds.extend(marker.coordinate);
      });

      // Ajustez la carte pour s'adapter aux limites
      //mapRef?.current?.getMap()?.fitBounds(bounds);

      console.log("ref", mapRef?.current);
    }
  }, [active, markers]);

  const containerStyle = {
    width: "100%",
    height: 800,
  };

  const center = {
    lat: -3.745,
    lng: -38.523,
  };

  return (
    <>
      <Typography variant="h1" sx={{ textAlign: "center" }}>
        {race?.name?.fr} : {active ? "LOAD" : "GO !"}
      </Typography>
      <Button onClick={() => setActive(!active)}>Clique</Button>
      <LoadScript googleMapsApiKey="AIzaSyDBLmDNmHmQadCJ_I5MAV7guy2sGA__gUY">
        <GoogleMap
          ref={mapRef}
          onLoad={() => setActive(true)}
          mapContainerStyle={containerStyle}
          center={markers[0].coordinate}
          zoom={15}
        >
          {/* Vous pouvez ajouter plusieurs marqueurs comme celui ci-dessous */}
          {active &&
            markers.map((marker: any, index: number) => {
              return (
                <Marker
                  onClick={() => setMarkerIndexSelected(index)}
                  draggable={true}
                  key={index}
                  icon={{
                    path: window.google.maps.SymbolPath.CIRCLE, // utilise un cercle
                    scale: index === markerIndexSelected ? 15 : 10, // taille du cercle
                    fillColor: theme.palette.primary.main,
                    fillOpacity: index === markerIndexSelected ? 1 : 0.5,
                    strokeWeight: 0,
                    strokeColor: "#000000",
                  }}
                  position={marker.coordinate}
                  //animation={window.google.maps.Animation.BOUNCE}
                  label={{
                    text: index.toString(),
                    color: "white",
                    fontSize: index === markerIndexSelected ? "16px" : "10px",
                    fontWeight: "bold",
                    fontFamily: "Caprasimo",
                  }}
                />
              );
            })}
        </GoogleMap>
      </LoadScript>
    </>
  );
};

export default Race;

// {
//   lat: race?.markers?.[0]?.coordinate.latitude,
//   lng: race?.markers?.[0]?.coordinate.longitude,
// })
